export const Spacer = ({ size, horizontal }: { size: number; horizontal?: boolean }) => {
  const style = horizontal ? { width: size } : { height: size };
  return <div style={style} />;
};
